import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ga{min-height:100vh;}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.gb{align-self:center;}.ssr-plugin'
import '.at{flex-shrink:0;}.ssr-plugin'
import '.gc{padding-block:1rem;}.ssr-plugin'
import '.fd{gap:0.75rem;}.ssr-plugin'
import '.gd{height:3rem;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.ge{height:0.25rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.gf{border-radius:999px;}.ssr-plugin'
import '.gg{background:var(--gray-200);}.ssr-plugin'
import '.bc{height:100%;}.ssr-plugin'
import '.cl{background:var(--brand-primary);}.ssr-plugin'
import '.gh{transition:width 0.3s ease;}.ssr-plugin'
import '.bd{flex:1;}.ssr-plugin'
import '.d5{min-height:0px;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.gi{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
  progress,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
  progress?: { current: number; total: number }
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a b ga e2"
      >
        <div className="ab gb at"
          style={{
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          <nav className="gc a b fd"
          >
            <div className="gd a ae t ah"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </div>
            {progress && progress.total > 0 && (
              <div className="ge n gf gg"
              >
                <div className="bc gf cl gh"
                  style={{
                    width: `${(progress.current / progress.total) * 100}%`,}}
                />
              </div>
            )}
          </nav>
        </div>
        <div className="bd d5 a b r gi ab gb"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
